export default function TopicsSection() {
  const topics = [
    { name: '明星恋情曝光', hot: true, count: '12.8万讨论' },
    { name: '综艺幕后黑幕', hot: true, count: '9.6万讨论' },
    { name: '网红翻车合集', hot: true, count: '8.3万讨论' },
    { name: '影视剧争议', hot: false, count: '6.7万讨论' },
    { name: '品牌代言风波', hot: true, count: '5.9万讨论' },
    { name: '直播带货内幕', hot: false, count: '5.2万讨论' },
    { name: '选秀黑箱操作', hot: false, count: '4.8万讨论' },
    { name: '音乐圈抄袭门', hot: true, count: '4.3万讨论' },
    { name: '时尚圈恩怨', hot: false, count: '3.7万讨论' },
    { name: '体育圈八卦', hot: false, count: '3.2万讨论' },
    { name: '海外娱乐圈', hot: false, count: '2.8万讨论' },
  ];

  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-400 bg-primary-100/15 px-3 py-1 rounded-full mb-4 whitespace-nowrap">
            <i className="ri-hashtag"></i>
            Trending Topics
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500">今日黑料最新讨论风向标，看看大家都在聊什么</p>
        </div>

        <div className="flex flex-wrap justify-center gap-2.5">
          {topics.map((topic) => (
            <a
              key={topic.name}
              href="#ranking"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full text-sm transition-all cursor-pointer whitespace-nowrap ${
                topic.hot
                  ? 'bg-accent-100/15 text-accent-300 border border-accent-300/20 hover:bg-accent-100/25 hover:border-accent-300/40'
                  : 'bg-background-100 text-foreground-400 border border-background-200/60 hover:bg-background-200 hover:text-foreground-300'
              }`}
            >
              <span>{topic.name}</span>
              {topic.hot && (
                <span className="flex items-center gap-0.5 text-xs">
                  <i className="ri-fire-line text-[10px]"></i>
                  热
                </span>
              )}
              <span className="text-xs text-foreground-600">{topic.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}